import { cn } from "@app/lib/utils";
import { linksDrawerAtom } from "@design-system/atoms";
import { Link } from "@design-system/components";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@design-system/components/ui";
import { headerLinks } from "@design-system/data";
import { ChevronIcon, InvestmentIcon } from "@design-system/icons";
import { MobileChangeLanguageButton } from "@design-system/layouts/CommonLayout/MobileChangeLanguageButton";
import { trans } from "@mongez/localization";
import { useEffect } from "react";

export function MobileLinksDrawer() {
  const opened = linksDrawerAtom.useOpened();

  useEffect(() => {
    if (opened) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [opened]);

  return (
    <div
      className={cn(
        "z-60 bg-cinder absolute start-0 grid w-full grid-rows-[0fr] bg-primary transition-all duration-500",
        opened && "grid-rows-[1fr]",
      )}
    >
      <div
        className={cn(
          "h-0 overflow-hidden duration-500",
          opened && "h-[90vh] pb-8",
        )}
      >
        <div className="scrollbar-hide flex h-full flex-col gap-1 overflow-y-scroll !border-t border-white !border-opacity-10 p-8">
          <Accordion type="single" collapsible>
            {headerLinks.map((link, index) => (
              <div key={index}>
                {!link.children && (
                  <Link
                    to={link.href}
                    onClick={linksDrawerAtom.close}
                    className="block py-4 text-white"
                  >
                    {trans(link.title)}
                  </Link>
                )}
                {link.children && (
                  <AccordionItem key={link.id} value={String(link.id)}>
                    <AccordionTrigger className="text-base font-normal text-white">
                      {trans(link.title)}
                    </AccordionTrigger>
                    <AccordionContent>
                      <div className="flex flex-col gap-1">
                        <Accordion type="single" collapsible>
                          {link.children.map((child, childIndex) =>
                            child.children ? (
                              <AccordionItem
                                key={childIndex}
                                value={`${link.id}-${childIndex}`}
                                className="border-b border-white/10"
                              >
                                <AccordionTrigger className="py-4 text-base font-normal text-white !text-opacity-50">
                                  {trans(child.title)}
                                </AccordionTrigger>
                                <AccordionContent>
                                  <div className="flex flex-col gap-1 ps-4">
                                    {child.children.map(
                                      (grandChild, grandChildIndex) => (
                                        <Link
                                          onClick={linksDrawerAtom.close}
                                          to={grandChild.href}
                                          className="py-3 text-white !text-opacity-40"
                                          key={grandChildIndex}
                                        >
                                          {trans(grandChild.title)}
                                        </Link>
                                      ),
                                    )}
                                  </div>
                                </AccordionContent>
                              </AccordionItem>
                            ) : (
                              <Link
                                onClick={linksDrawerAtom.close}
                                to={child.href}
                                className="block py-4 text-white !text-opacity-50"
                                key={childIndex}
                              >
                                {trans(child.title)}
                              </Link>
                            ),
                          )}
                        </Accordion>
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                )}
              </div>
            ))}
          </Accordion>
          <div className="my-6 flex flex-col gap-5">
            <a
              href="https://www.saudiexchange.sa/wps/portal/saudiexchange/hidden/company-profile-main/!ut/p/z1/04_Sj9CPykssy0xPLMnMz0vMAfIjo8ziTR3NDIw8LAz83d2MXA0C3SydAl1c3Q0NvE30I4EKzBEKDMKcTQzMDPxN3H19LAzdTU31w8syU8v1wwkpK8hOMgUA-oskdg!!/?companySymbol=2240"
              target="_blank"
              onClick={linksDrawerAtom.close}
              className="flex items-center justify-between rounded-[3.6rem] bg-white bg-opacity-5 px-6 py-4"
            >
              <div className="flex items-center gap-4">
                <InvestmentIcon className="h-8 w-8" />
                <span className="text-white">{trans("investment")}</span>
              </div>
              <ChevronIcon className="-rotate-90 rtl:rotate-90" />
            </a>
            <MobileChangeLanguageButton />
          </div>
        </div>
      </div>
    </div>
  );
}
